"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledSwitchPageSectionContainer=void 0;const styled_components_1=__importDefault(require("styled-components"));exports.StyledSwitchPageSectionContainer=styled_components_1.default.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  font-family: Poppins;
  font-size: 14px;
  /* margin-top: 30px; */
`;